/**
 * The Application-experience board's route and URL vocabulary.
 *
 * The board reads one payload, `/fo/console/experience`, and carries no user
 * identifier at all: everything on it is a count, a median or a share over the
 * apps the browser extension reports on. So there is no reason gate here and no
 * `?mail=` — the per-user layer stays on `/dynamics/investigate`, behind its own
 * gate.
 *
 * The lookback param is deliberately the **same** `?lookback=` the console uses
 * (`features/dynamics/params.ts`), because it is the same union of KQL windows on
 * the same workspace. A link that carries a window from one board to the other
 * keeps meaning it.
 */

/** The L1 board. */
export const EXPERIENCE_PATH = "/experience";

/** In-page anchors the app tiles link down to. */
export const EXPERIENCE_TREND_ANCHOR = "xp-trend";
export const EXPERIENCE_CONTEXTS_ANCHOR = "xp-contexts";
export const EXPERIENCE_PROBES_ANCHOR = "xp-probes";

/**
 * Single-value param: which app the trend, the page-key ranking and the probe
 * chart are narrowed to. Absent means every app — the board's default, because
 * the first question is "which app is the bad one".
 */
export const APP_PARAM = "app";
